<template>
    <div class="preface-box">
        <v-touch v-on:swipedown="swipedown" v-on:swipeup="swipeup" class="wrapper">
            <img src="@/assets/image/preface/bg.png" alt="" class="face" />
            <div class="qianyan">
                <!-- <img src="@/assets/image/preface/title-bg.png" alt="" class="titleimg" /> -->
                <span class="titleimg">{{ ditel.title }}</span>
            </div>
            <div class="docx">
                <span v-html="ditel.details"> </span>
            </div>
        </v-touch>
    </div>
</template>

<script>
import { getAction } from "@/api/manage.js";
export default {
    created() {
        this.loadData();
    },
    data() {
        return {
            ditel: {},
        };
    },
    methods: {
      swipeup: function () {
      this.$router.push("/petrhome");
    },
        swipedown: function () {
            this.$router.push("/");
        },
        loadData() {
            getAction("/act/preface/queryById", {
                id: "1356796105491389569",
            }).then((res) => {
                if (res.success) {
                    this.ditel = res.result;
                }
            });
        },
    },
};
</script>

<style lang='scss'>
.preface-box {
    .face {
        width: 100%;
        position: fixed;
        bottom: 0;
        opacity: .6;
    }
    .qianyan {
        background: url(~@/assets/image/preface/preface-bg.png) no-repeat;
        background-size: 100% 100%;
        width: 35%;
        font-size: 1.3rem;
        font-weight: bold;
        line-height: 50px;
        color: #fefefe;
        text-align: center;
        letter-spacing: 5px;
        margin: 100px auto 20px;
        -webkit-animation: scale-in-tr 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)
            both;
        animation: scale-in-tr 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
    }
    .docx {
        padding: 0px 40px;
        font-size: 15px;
        line-height: 29px;
        letter-spacing: 0px;
        color: #333333;
        text-indent: 2em;
        -webkit-animation: scale-in-top 0.5s
            cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
        animation: scale-in-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
        text-align: justify;
        margin-bottom: 150px;
    }
}
</style>
